import { Component, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { ReactiveFormsModule, FormGroup, FormControl, Validators } from '@angular/forms';
import { AuthService } from '../../core/services/auth';

@Component({
  selector: 'app-login',
  imports: [ReactiveFormsModule],
  templateUrl: './login.html',
  styleUrl: './login.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginComponent {
  private auth = inject(AuthService);
  private router = inject(Router);

  form = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required])
  });

  errorMessage = signal('');
  isLoading = signal(false);

  onSubmit() {
    if (this.form.invalid) {
      this.errorMessage.set('Please enter both email and password.');
      return;
    }

    this.isLoading.set(true);
    this.errorMessage.set('');

    const { email, password } = this.form.value;

    this.auth.login({ email, password }).subscribe({
      next: (user: any) => {
        this.isLoading.set(false);
        if (user?.force_password_reset === true) {
          this.router.navigate(['/change-password']);
        } else {
          this.router.navigate(['/dashboard']);
        }
      },
      error: (err) => {
        this.isLoading.set(false);
        const detail = err?.error?.detail ?? err?.error?.message;
        if (typeof detail === 'string') {
          this.errorMessage.set(detail);
        } else if (err?.status === 401 || err?.status === 403) {
          this.errorMessage.set('Invalid email or password. Please try again.');
        } else {
          this.errorMessage.set('An error occurred during login. Please try again later.');
        }
      }
    });
  }
}
